import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseQuestionComponent } from '../base-question.component';

/**
 * Helper text question component.
 * Displays helper text/information in the form.
 * Uses Angular signals inherited from BaseQuestionComponent.
 */
@Component({
  selector: 'app-helper-text-question',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './helper-text-question.component.html',
  styleUrl: './helper-text-question.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelperTextQuestionComponent extends BaseQuestionComponent {
  onLabelChange(value: string): void {
    this.updateLabel(value);
  }
}

